/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SelectorItemObjectFromJSON, SelectorItemObjectToJSON } from './SelectorItemObject';
export function ResponseDataSelectorObjectCommonDataFromJSON(json) {
    return ResponseDataSelectorObjectCommonDataFromJSONTyped(json, false);
}
export function ResponseDataSelectorObjectCommonDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        selectorItemObjects: !exists(json, 'selector_item_objects')
            ? undefined
            : json['selector_item_objects'].map(SelectorItemObjectFromJSON)
    };
}
export function ResponseDataSelectorObjectCommonDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        selector_item_objects: value.selectorItemObjects === undefined
            ? undefined
            : value.selectorItemObjects.map(SelectorItemObjectToJSON)
    };
}
